import AssetWrapper from 'atoms/Asset/AssetWrapper';
import Stack from 'atoms/Layout/Stack/Stack';
import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';

const HeroImageBlock = (): JSX.Element => {
  const { image } = useStaticQuery(graphql`
    {
      image: contentfulAsset(contentful_id: { eq: "3GKt6s6aluIDxqTydxGYhj" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 2400)
      }
    }
  `);

  return (
    <Stack
      padding={['spacing-none', 'spacing-4xl']}
      paddingSm={['spacing-none', 'spacing-xl']}
    >
      <AssetWrapper
        imageProps={{
          image: image.gatsbyImageData,
          alt: 'Hero Image',
        }}
        maxWidth={1280}
        radius='radius-2xl'
      />
    </Stack>
  );
};

export default HeroImageBlock;
